import React, { Component } from 'react'
import { Tab } from 'semantic-ui-react'

import { applicableProfiles, findFeed } from '../../all_cards/aufschaltung.js'
import S3PushOverview from './S3PushOverview.js'

class ApiS3Push extends Component {

  render () {
    const { context } = this.props

    if (context.navigation.category === 'profile') {
      const feed = findFeed({
        aufschaltung: context.aufschaltung,
        navigation: { profile: context.navigation.profile,
        api: 's3push' }})
      return (
        <div className='apis3push'>
          <S3PushOverview
            aufschaltung_id={context.aufschaltung.id}
            feed={feed}
            userInfo={context.userInfo}
            lang={context.lang} />
        </div>
      )
    } else if (context.navigation.category === 'api') {
      return (
        <div className='apis3push'>
          <Tab menu={{ secondary: true, pointing: true, className: 'tab-wrapped'}} defaultActiveIndex={0}
            panes={ applicableProfiles(context).map((profile, i) => {
              const feed = findFeed({
                aufschaltung: context.aufschaltung,
                navigation: { profile: profile.nickname,
                api: 's3push' }})
                return (
                  { menuItem: profile.nickname,
                    render: () => {
                      return (
                        <Tab.Pane key={i} attached={false}>
                          <S3PushOverview
                            aufschaltung_id={context.aufschaltung.id}
                            feed={feed}
                            userInfo={context.userInfo}
                            lang={context.lang} />
                        </Tab.Pane>
                      )}
                  })
          })} />
        </div>
      )
    }
  }
}

export { ApiS3Push }



// WEBPACK FOOTER //
// ./src/components/push_apis/ApiS3Push.js